import { useEffect } from 'react'
import { Container, Row, Col, Card, Alert } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { getSchedule } from '../../../actions/calendarActions'
import Loader from '../../../components/loaders/Loader'

export default function ScheduleView() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { schedule, loading, calendarError } = useSelector(state => state.calendar)

    useEffect(() => {
        dispatch(getSchedule())
    }, [dispatch])

    if (loading && (!schedule || schedule.length === 0)) return <Loader />

    if (calendarError) return (
        <Container className='my-3 p-5'>
            <Alert variant='danger'>{calendarError}</Alert>
        </Container>
    )

    const days = [t('teacher.calendar.monday'), t('teacher.calendar.tuesday'), t('teacher.calendar.wednesday'), t('teacher.calendar.thursday'), t('teacher.calendar.friday'), t('teacher.calendar.saturday')]
    const scheduleByDay = days.map((day, idx) => ({
        name: day,
        events: (schedule || []).filter(s => {
            const d = new Date(s.startDatetime)
            return d.getDay() === idx + 1
        })
    }))

    return (
        <Container className='my-3 p-5'>
            <Row>
                <Col>
                    <h3 className='fw-bold mb-1'>{t('teacher.calendar.weekly')}</h3>
                    <p className='text-muted mb-4'>{t('teacher.calendar.scheduleTitle')}</p>
                </Col>
            </Row>
            <Row className='g-3'>
                {scheduleByDay.map(day => (
                    <Col key={day.name} xs={12} md={6} xl={4}>
                        <Card className='border-0 shadow-sm rounded-4 h-100'>
                            <Card.Body className='p-4'>
                                <h5 className='fw-bold mb-3'>{day.name}</h5>
                                {day.events.length > 0 ? day.events.map(evt => (
                                    <div key={evt._id} className='p-2 mb-2 bg-light rounded-3'>
                                        <p className='fw-semibold mb-0' style={{ fontSize: '14px' }}>{evt.groupName || t('teacher.calendar.classFallback')}</p>
                                        <p className='text-muted mb-0' style={{ fontSize: '12px' }}>
                                            {evt.startDatetime ? new Date(evt.startDatetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                                            {evt.classroom ? ` - ${evt.classroom}` : ''}
                                        </p>
                                    </div>
                                )) : <p className='text-muted' style={{ fontSize: '13px' }}>{t('teacher.calendar.noClasses')}</p>}
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    )
}
